import { Link } from "react-router-dom";
import { useRegion } from "../../../context/RegionContext";

const BlogCard = ({ blog }) => {
    const { region } = useRegion();

    // Fallback image if none provided in API
    // const fallbackImage = "https://images.unsplash.com/photo-1533560235473-99d6511a766c?q=80&w=2070&auto=format&fit=crop";

    // Map API fields to UI
    const cardData = {
        id: blog.WPTextBlockId,
        slug: blog.WPTextBlockId, // Using ID as slug since API doesn't provide one
        title: blog.TextBlockTitle || blog.TextBlockName,
        date: new Date(blog.ChangeDateTime).toLocaleDateString('en-NZ', { day: 'numeric', month: 'long', year: 'numeric' }),
        excerpt: blog.TextBlockShortContent,
        author: blog.ChangeUserName || "Tuatara Team",
        image: blog.Pictures?.[0]?.url
    };

    return (
        <div
            className="group block bg-white border border-[#eee] overflow-hidden transition-all duration-500 hover:transform hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(0,0,0,0.1)]"
        >
            {/* Image Container */}
            <div className="relative w-full aspect-[4/3] overflow-hidden  flex items-center justify-center">
                <img
                    src={cardData.image}
                    alt={cardData.title}
                    className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105  border border-[black]"
                />

                {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div> */}

                <div className="absolute bottom-4 left-4">
                    <span className="bg-[#7ABF5B] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                        {cardData.author}
                    </span>
                </div>
            </div>


            {/* Content Container */}
            <div className="p-5 md:p-8">
                <div className="flex items-center gap-4 mb-3 text-gray-500 text-sm">
                    <span className="montserrat-regular">{cardData.date}</span>
                </div>
                <h3 className="kuunari-bold text-xl md:text-2xl text-[#333] mb-4 group-hover:text-[#7ABF5B] transition-colors duration-300 line-clamp-2 uppercase">
                    {cardData.title}
                </h3>
                <p className="montserrat-regular text-gray-600 line-clamp-3 leading-relaxed mb-6">
                    {cardData.excerpt}
                </p>
                <Link
                    to={`/${region}/${cardData.id}`}
                    onClick={() => window.scrollTo(0, 0)}
                    className="inline-flex items-center text-[#7ABF5B] font-bold text-sm tracking-widest uppercase group-hover:gap-4 transition-all duration-300 pointer-events-auto"
                >
                    Read Story
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </Link>
            </div>
        </div>
    );
};

export default BlogCard;
